import React from 'react';
import PropTypes from 'prop-types';

import IMG_LOGO from '../../../../assets/images/logo.svg';

const Header = ({ step }) => {
  const htmlStepBars = [];
  for (let i = 1; i <= 6; i++) {
    htmlStepBars.push(<div
      key={i}
      className={`${i <= step ? 'bg-[#3988E2]' : 'bg-[#E2E2E2]'} w-1/6 h-1 shadow-md ${i < 6 ? 'mr-1' : ''}`}
    />);
  }
  return (
    <div className="relative pt-5 pb-6">
      <img src={IMG_LOGO} alt="logo" className="m-auto md:ml-0" />
      <div className="absolute w-full h-1 flex justify-evenly bottom-0">
        {htmlStepBars}
      </div>
      <div className="absolute right-0 top-5 w-28 text-right invisible md:visible">
        <div className="font-medium text-base text-[#263952] leading-4">Questions?</div>
        <div className="font-bold text-lg text-[#D82027]">
          <a className="no-underline text-[#D82027] cursor-pointer" href="tel:8888118798" target="_blank" rel="noreferrer">888-811-8798</a>
        </div>
      </div>
    </div>
  );
};

Header.propTypes = {
  step: PropTypes.number,
};

Header.defaultProps = {
  step: 0,
};

export default Header;
